import { useState, createContext, useContext, useMemo } from 'react';

import { useFilterContext } from './FilterContext';

export const DesignInfoModalContext = createContext({ isOpen: false });

export const useDesignInfoModalContext = () =>
  useContext(DesignInfoModalContext);

export const useDesignInfoModalTitle = () => {
  const { sectionGroupId } = useFilterContext().state;
  const hasSectionGroupFilter = !!sectionGroupId;

  return hasSectionGroupFilter ? 'Section Group Design' : 'Project Design';
};

export const DesignInfoModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const value = useMemo(() => ({ isOpen, setIsOpen }), [isOpen]);

  return (
    <DesignInfoModalContext.Provider value={value}>
      {children}
    </DesignInfoModalContext.Provider>
  );
};
